/**
 * @desc Universal search component module
 */
;(function () {
  angular
    .module('contrast.search')
    .directive('csUniversalSearch', [csUniversalSearch])

  function csUniversalSearch() {
    return {
      restrict: 'E',
      scope: true,
      templateUrl: 'views/common/cs-universal-search.html',
      controller: 'csUniversalSearchCtrl',
      controllerAs: 'searchCtrl'
    }
  }
})()
